import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import Flag from '../../constant/flag';
var moment = require('moment');

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor(private auth: AuthService) {}

  public formatInsStateValues(rowDataValue) {
    const colors = {
      red: '#FF0000',
      orange: '#EC7A08',
      black: '#000000',
      blue: '#0058BA',
      green: '#008000',
    };
    let color;
    if (rowDataValue.value.indexOf('Flex Cancelled') === 0) {
      color = colors.red;
    } else if (rowDataValue.value.indexOf('Flex Hold (') === 0) {
      color = colors.orange;
    } else if (rowDataValue.value.indexOf('PO Complete') !== -1) {
      color = colors.green;
    } else if (rowDataValue.value.indexOf('shipped') !== -1) {
      color = colors.green;
    } else if (rowDataValue.value.indexOf('PO Pending') !== -1) {
      color = colors.blue;
    } else if (rowDataValue.value.indexOf('(Message Pending)') !== -1) {
      color = colors.orange;
    } else if (rowDataValue.value.indexOf('Transferred') !== -1) {
      color = colors.black;
    } else if (rowDataValue.value.indexOf('Error') !== -1) {
      color = colors.red;
    } else {
      color = colors.black;
    }
    return {
      color: color,
    };
    // else if ( rowDataValue.value == 'Flex Hold Removed( PO Complete)' ) { color = colors.green; }
    // else if ( rowDataValue.value.substring(0, 18) == 'Flex Hold Removed (' ) { color = colors.blue; }
  }

  public currencyFormatter(params) {
    if (!params.value) {
      return '';
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });

    return formatter.format(params.value);
  }

  public getDisabledValue(po) {
    if (['distributor', 'admin'].indexOf(this.auth.getUserType()) === -1) {
      return true;
    }
    if (po.status_flex === Flag.hold || po.flag_supplier === Flag.hold) {
      return true;
    }
    if (po.status_flex === Flag.cancelled || po.flag_supplier === Flag.cancelled) {
      return true;
    }
    return false;
  }

  public formatDate = function(params) {
    const options = {
      timeZoneName: 'short',
      weekday: undefined,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };
    if(params.value)
      return new Date(params.value).toLocaleString('en-US', options);
    else
      return new Date(params).toLocaleString('en-US', options);
  };

  public adminFormatDate = function(params) {
    var m = moment(params.value);
    return m.format('YYYY-MM-DD HH:mm z');
  };

  public getFlagDisplay = (flag_supplier, flag_distributor) => {
    flag_supplier = flag_supplier && flag_supplier.toLowerCase();
    flag_distributor = flag_distributor && flag_distributor.toLowerCase();

    let supplierFlag;

    if (flag_supplier === Flag.cancelled) {
      supplierFlag = 'Supplier Cancelled';
    } else {
      supplierFlag = flag_supplier === Flag.hold ? 'Supplier Hold' : '';
    }
    let distributorFlag;
    if (flag_distributor === Flag.cancelled) {
      distributorFlag = 'Customer Cancelled';
    } else {
      distributorFlag = flag_distributor === Flag.hold ? 'Distributor Hold' : '';
    }

    if (flag_supplier && flag_supplier !== Flag.hold_released) {
      return `${supplierFlag}${distributorFlag ? ' (' + distributorFlag + ')' : ''}`;
    }

    return `${supplierFlag}${distributorFlag ? ' (' + distributorFlag + ')' : ''}`;
  };

  public greenOrRed(flag) {
    return flag.value?{color: 'green'}:{color: 'red'};
  }
  public blackOrRed(flag) {
    return flag.value?{}:{color: 'red'};
  }

  public dateFilterParams = {
    filterOptions: [
      'inRange', 'greaterThan', 'lessThan'
    ]
  }
}
